/* eslint-disable local-rules/set-state-in-use-effect */
import {useCurrentPageType} from '@aboutyou/router';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React, {useRef} from 'react';
import {CouponDeepLinkActivation} from '../CouponDeepLinkActivation/CouponDeepLinkActivation';
import {useUnlockCouponInfo} from './hooks/useUnlockCouponInfo';

export interface UnlockCouponInfoProps {
  LayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const UnlockCouponInfo: React.FC<UnlockCouponInfoProps> = React.memo(
  function UnlockCouponInfo({LayoutComponent}) {
    const {isOpen, couponActivationResponse} = useUnlockCouponInfo();
    const entryPageType = useRef(useCurrentPageType()).current;

    // no UI to render for article detail page, we handle success/error with toasts there
    if (entryPageType === 'articleDetail') {
      return null;
    }

    return (
      <CouponDeepLinkActivation
        data-testid="unlock-coupon-info-flyout"
        isOpen={isOpen}
        LayoutComponent={LayoutComponent}
        {...couponActivationResponse}
      />
    );
  },
);
